import React, { useState } from "react";
import $ from 'jquery';
import { AiOutlineLogout } from "react-icons/ai";

const Profile = (props) => 
{
    const userData = props.userJson;
    const [imgUrl, setimgUrl] = useState(userData.picture_url);
    
    $(".NumberValid").on("input", function () {
        var e = '۰'.charCodeAt(0);
        this.value = this.value.replace(/[۰-۹]/g, function(t) {
            return t.charCodeAt(0) - e;
        });
        // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
        e = '٠'.charCodeAt(0);
        this.value = this.value.replace(/[٠-٩]/g, function(t) {
            return t.charCodeAt(0) - e;
        });
        this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    });

    $(".valid-empty").on("blur", function () {
        var value_check = $(this).val();
        value_check = value_check.replace(/\s/g, '');
        if (value_check === null || value_check.length < 1) {
            $(this).removeClass("is-valid").addClass("is-invalid");
            $(this).next(".invalid-feedback").text("فیلد نمی تواند خالی باشد.");
            return false;
        }
        $(this).removeClass("is-invalid").addClass("is-valid");
    });

    // function checkItem(e)
    // {
    //     var value_check = $(e).val();
    //     value_check = value_check.replace(/\s/g, '');
    //     if (value_check === null || value_check.length < 1) {
    //         $(e).removeClass("is-valid").addClass("is-invalid");
    //         $(e).next(".invalid-feedback").text("فیلد نمی تواند خالی باشد.");
    //         return false;
    //     }
    //     $(e).removeClass("is-invalid").addClass("is-valid");
    // }
    
    // function submitForm()
    // {
    //     $('.valid-empty').each(function(i, obj) {
    //         checkItem($(obj));
    //     });
    //     var numItems = $('.is-invalid').length
    //     if (numItems === 0)
    //     {
    //         let first_name = $("#User_Fname").val();
    //         let last_name = $("#User_Lname").val();
    //         let bank_name = $("#User_BankName").val();
    //         let bank_shaba = $("#User_BankShaba").val();
    //         let national_id = $("#User_CodeMeli").val();
    //         let shop_name = $("#User_StoreName").val();
    //         let address = $("#User_Address").val();
    //         let postal_code = $("#User_PostalCode").val();
    //         let city_id = $("#City_ID").val();
    //         let text = '{ "userForm" : ' +
    //         '{ "first_name":"'+ first_name +'" , "last_name":"' + last_name + '"' +
    //         ',"bank_name":"'+ bank_name +'" , "bank_shaba":"'+ bank_shaba + '"' +
    //         ',"address":"'+ address +'" , "postal_code":"'+ postal_code + '", "city_id":"'+ city_id + '"' +
    //         ',"national_id":"'+ national_id +'" , "shop_name":"' + shop_name + '" }}'; 
    //         const myObject = JSON.parse(text);  
    //         props.saveFullProfile(myObject);
    //         return true;
    //     }
    // }
    function handleFileSelect(evt)
    {
        if (evt.target.files && evt.target.files.length > 0) 
        {
            let imgSize = evt.target.files[0].size;
            if (imgSize <= 4000000)
            {
                const reader = new FileReader();    
                reader.addEventListener("load", () => {
                    const image = reader.result;
                    setimgUrl(image);
                });
                reader.readAsDataURL(evt.target.files[0]);
            }
            else
            {
                const errorMessage = "حجم فایل نباید بیشتر از 4 مگابایت باشد.";
                props.toggleErrorMessage(errorMessage);
                props.toggleError();
            }
        }
    }
    return ( 
        <div className='p-2 container-fluid'>
            <div className='row Profile'>
                <div className='item info dina-bc-blue file-input'>
                    <input type="file" id="inputId" className="file"  accept="image/*" onChange={handleFileSelect}></input>
                    <label htmlFor="inputId" className="img"><img id="userIMG" src={(imgUrl !== null) ? imgUrl : userData.picture_url} className="img-circle" alt='user'/></label>
                    <p className='text-dark wp-text my-2 text-white'> {userData.full_name} </p>
                    <p className='text-dark wp-text my-2 text-white'> {userData.semat_title} </p>
                    <p className='text-dark wp-text-large mb-2 text-white'>{userData.mobile}</p>
                </div>
                <div className='item data body-padding-bottom'>
                    <div className="col-12 mt-2">
                        <label className="wp-text">نام<span className="text-danger">*</span></label>
                        <input type="text" defaultValue={userData.first_name} id="User_Fname" className="form-control form-control-sm wp-input-text rounded-pill valid-empty" tabIndex="1" disabled/>
                        <div className="invalid-feedback wp-text-small"></div>
                    </div>
                    <div className="col-12 mt-2">
                        <label className="wp-text">نام خانوادگی<span className="text-danger">*</span></label>
                        <input type="text" defaultValue={userData.last_name} id="User_Lname" className="form-control form-control-sm wp-input-text rounded-pill valid-empty" tabIndex="2" disabled/>
                        <div className="invalid-feedback wp-text-small"></div>
                    </div>
                    <div className="col-12 mt-2">
                        <label className="wp-text">سمت سازمانی<span className="text-danger">*</span></label>
                        <input type="text" defaultValue={userData.semat_title} className="form-control form-control-sm wp-input-text rounded-pill valid-empty" tabIndex="3" disabled/>
                        <div className="invalid-feedback wp-text-small"></div>
                    </div>
                    <div className="col-12 mt-2">
                        <label className="wp-text">موبایل<span className="text-danger">*</span></label>
                        <input type="text" defaultValue={userData.mobile} className="form-control form-control-sm wp-input-text rounded-pill valid-empty NumberValid" tabIndex="4" disabled/>
                        <div className="invalid-feedback wp-text-small"></div>
                    </div>
                    <div className="col-12 mt-2">
                        <label className="wp-text">کدملی<span className="text-danger">*</span></label>
                        <input type="text" id="User_CodeMeli" defaultValue={userData.national_id} className="form-control form-control-sm wp-input-text rounded-pill valid-empty NumberValid" tabIndex="5" disabled/>
                        <div className="invalid-feedback wp-text-small"></div>
                    </div>
                    <div className="col-12 mt-2">
                        <label className="wp-text">نام بانک<span className="text-danger mr-1">*</span></label>
                        <input type="text" id="User_BankName" defaultValue="بانک قرض الحسنه مهر ایران" className="form-control form-control-sm wp-input-text rounded-pill valid-empty" tabIndex="11" disabled/>
                        <div className="invalid-feedback wp-text-small"></div>
                    </div>
                    <div className="col-12 mt-2">
                        <label className="wp-text">شماره شبا<span className="text-danger mr-1">*</span></label>
                        <input type="text" defaultValue={userData.bank_shaba} id="User_BankShaba" className="form-control form-control-sm wp-input-text rounded-pill NumberValid valid-empty" tabIndex="12" disabled />
                        <div className="invalid-feedback wp-text-small"></div>
                    </div>
                    <div className="col-12 mt-2">
                        {/* <button id="SubmitForm" className="btn dina-btn-blue rounded-pill float-right" onClick={submitForm} ><AiFillSave /> ثبت اطلاعات</button> */}
                        <button onClick={() => props.handleLouOut()} className="btn dina-btn-orange rounded-pill float-left"><AiOutlineLogout /> خروج</button>
                    </div>
                </div>
            </div>
        </div>     
    );
}
 
export default Profile;